import type { ReviewNoyau } from '../schemas/session-review.js';

/**
 * What is wrong with a noyau of the reviewer (relecture.md §8, D14), or null.
 * Shared so the page can grey a choice the server would refuse
 * (`review-noyau-invalid`) and the write routes refuse it with one voice.
 *
 * - `second-without-doubt` - a second candidate exists only « avec doute »;
 * - `second-without-noyau` - nothing for it to be the second of;
 * - `second-is-noyau` - « ou bien, peut-être » the same noyau is no alternative;
 * - `unreadable-with-choice` - « Pas de noyau lisible » empties the choice.
 *
 * An empty choice (no noyau, not unreadable) is legal: it clears the noyau and
 * keeps the note.
 */
export type ReviewNoyauProblem =
  | 'second-without-doubt'
  | 'second-without-noyau'
  | 'second-is-noyau'
  | 'unreadable-with-choice';

export function reviewNoyauProblem(
  choice: Pick<ReviewNoyau, 'noyau' | 'certainty' | 'second' | 'unreadable'>,
): ReviewNoyauProblem | null {
  if (choice.unreadable && (choice.noyau !== null || choice.second !== null)) {
    return 'unreadable-with-choice';
  }
  if (choice.second === null) return null;
  if (choice.noyau === null) return 'second-without-noyau';
  if (choice.second === choice.noyau) return 'second-is-noyau';
  if (choice.certainty !== 'doubtful') return 'second-without-doubt';
  return null;
}
